import { useTranslation } from "react-i18next";
import { legalText } from "@/i18n/publicLegalTranslations";

const LANGUAGES = [
  ["en", "EN"],
  ["pt", "PT"],
  ["zh", "中文"],
  ["fr", "FR"],
  ["es", "ES"],
  ["de", "DE"],
  ["it", "IT"],
  ["ru", "RU"],
];

export default function LegalPublicPage({ type }) {
  const { i18n } = useTranslation();

  const lang = (i18n.language || "en").split("-")[0];
  const legal = legalText(lang);
  const privacy = legal.privacy;

  const titles = {
    privacy: {
      en: "Privacy Policy",
      pt: "Política de Privacidade",
      zh: "隐私政策",
      fr: "Politique de confidentialité",
      es: "Política de privacidad",
      de: "Datenschutzerklärung",
      it: "Informativa sulla privacy",
      ru: "Политика конфиденциальности",
    },
    terms: {
      en: "Terms of Service",
      pt: "Termos de Serviço",
      zh: "服务条款",
      fr: "Conditions d’utilisation",
      es: "Términos del servicio",
      de: "Nutzungsbedingungen",
      it: "Termini di servizio",
      ru: "Условия использования",
    },
    deletion: {
      en: "User Data Deletion",
      pt: "Eliminação de Dados do Utilizador",
      zh: "用户数据删除",
      fr: "Suppression des données utilisateur",
      es: "Eliminación de datos del usuario",
      de: "Löschung von Benutzerdaten",
      it: "Eliminazione dei dati dell'utente",
      ru: "Удаление пользовательских данных",
    },
  };

  return (
    <main className="min-h-screen bg-slate-50 text-slate-800">
      <header className="bg-[#0B2545] text-white">
        <div className="max-w-5xl mx-auto px-6 py-8">
          <div className="text-2xl font-semibold tracking-wide">
            PANATLANTIK
          </div>
          <div className="text-sm text-slate-300 mt-1">
            International Real Estate & Investment Advisory
          </div>

          <div className="flex flex-wrap gap-2 mt-6">
            {LANGUAGES.map(([code, label]) => (
              <button
                key={code}
                onClick={() => i18n.changeLanguage(code)}
                className={`px-3 py-1 rounded border text-sm ${
                  lang === code
                    ? "bg-white text-[#0B2545]"
                    : "border-white/30 hover:bg-white/10"
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
      </header>

      <article className="max-w-5xl mx-auto px-6 py-12">
        <h1 className="text-3xl font-semibold text-[#0B2545]">
          {type === "privacy" ? privacy.title : (titles[type]?.[lang] || titles[type]?.en)}
        </h1>

        <p className="mt-3 text-sm text-slate-500">
          Panatlantik · Last updated: 2 October 2026
        </p>

        <div className="mt-10 rounded-lg border bg-white p-8">
          {type === "privacy" ? (
            <div className="space-y-8">
              {privacy.sections.map(([heading, text]) => (
                <section key={heading}>
                  <h2 className="text-xl font-semibold text-[#0B2545]">
                    {heading}
                  </h2>
                  <p className="mt-3 leading-7 text-slate-700">
                    {text}
                  </p>
                </section>
              ))}
            </div>
          ) : (
            <p className="leading-7">
              Legal content is being prepared for this section.
            </p>
          )}
        </div>

        <footer className="mt-12 border-t pt-6 text-sm text-slate-500">
          © 2026 Panatlantik. All rights reserved.
        </footer>
      </article>
    </main>
  );
}
